<template>
  <BasePanel>
    <component :is="components.details" v-if="components" />

    <ReviewSection>
      <PaymentSummaryCol />
    </ReviewSection>
  </BasePanel>
</template>

<script setup>
import BasePanel from "./BasePanel.ce.vue";
import PaymentSummaryCol from "./PaymentSummaryCol.ce.vue";
import ReviewSection from "./ReviewSection.ce.vue";

defineProps({
  components: {
    type: Object,
    required: true,
  },
});
</script>
